const CommonTypes = require('./Types.jsx');
const Config = require('../utility/Config.jsx');
const Item = require('./ItemV2.jsx');
const Name = require('../utility/Name.jsx');

// #region CONTAINER

const LineItemBlocks = {
    get: (group) => [
        ...CommonTypes.BlocksV2.content.get(group),
        {
            id: Name.Block.Inventory.Image,
            component: Item.Image.Component,
            config: {
                Block: Item.Image.TypeConfig.panel.block(),
                Style: Item.Image.TypeConfig.panel.style()
            },
            display: 'Item Image',
            group,
            image: ''
        },
        {
            id: Name.Block.Inventory.Meta,
            component: Item.Meta.Component,
            config: {
                Block: Item.Meta.TypeConfig.panel.block(),
                Style: Item.Meta.TypeConfig.panel.style()
            },
            display: 'Item Meta',
            group,
            image: ''
        }
    ]
}
const LineItemContainer = Config.withBlockRendering(Item.Container.Component, LineItemBlocks.get(), (props, block) => {
    if (!block.type) {
        return;
    }
    let blockExtras;
    if (props.onBlockExtras) {
        blockExtras = props.onBlockExtras(props, block);
    }
    switch (block.type.value) {
        case Name.Block.Columns:
            if (block.config && block.config.Block && block.config.Block.renderHeaderOnlyFirst) {
                if (!blockExtras) {
                    blockExtras = {};
                }
                blockExtras.renderHeader = props.index == 0;
            }
            break;
    }
    return blockExtras;
});

// #endregion CONTAINER

module.exports = {
    Container: {
        Blocks: LineItemBlocks,
        Component: LineItemContainer
    }
};